module.exports = __webpack_public_path__ + "static/media/orientation.2ea3b370.svg";